import { gql, useMutation } from '@apollo/client'

export const USER_PASSWORD_REQUEST_RESET = gql`
  mutation UserPasswordRequestReset($email: String!, $schoolId: ID!) {
    userPasswordRequestReset(
      input: {
        email: $email
        schoolId: $schoolId
        clientMutationId: "user-password-request-reset"
      }
    ) {
      status
    }
  }
`

export interface IUserPasswordRequestResetResult {
  userPasswordRequestReset: {
    status: string
  }
}

export interface IUserPasswordRequestResetInput {
  email: string
  schoolId: string
}

export const useUserPasswordRequestReset = () => {
  const [requestReset, { loading, error }] =
    useMutation<IUserPasswordRequestResetResult>(USER_PASSWORD_REQUEST_RESET)

  const handleRequestReset = async (input: IUserPasswordRequestResetInput) => {
    const response = await requestReset({ variables: input })
    return response.data?.userPasswordRequestReset
  }

  return { handleRequestReset, loading, error }
}
